import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { Outlet } from 'react-router';
import PrivacyPage from './Privacy';
import ConditionsPage from './Terms';

const TermsRoute: FuseRouteItemType = {
    path: 'terms',
    element: <Outlet />,
    auth: null,
    children: [
        {
            path: 'privacy',
            element: <PrivacyPage />,
            settings: {
                layout: {
                    config: {
                        navbar: {
                            display: false
                        },
                        toolbar: {
                            display: false
                        },
                        footer: {
                            display: false
                        },
                        leftSidePanel: {
                            display: false
                        },
                        rightSidePanel: {
                            display: false
                        }
                    }
                }
            }
        },
        {
            path: 'conditions',
            element: <ConditionsPage />,
            settings: {
                layout: {
                    config: {
                        navbar: {
                            display: false
                        },
                        toolbar: {
                            display: false
                        },
                        footer: {
                            display: false
                        },
                        leftSidePanel: {
                            display: false
                        },
                        rightSidePanel: {
                            display: false
                        }
                    }
                }
            }
        }
    ]
};

export default TermsRoute;